import { DynamicsAdapter } from 'app/model/adapters/dataflow/formatAdapters/dynamics.adapter';
import { DataFlowDSLAdapterRegistry, Metamodel, Owned } from 'shell-models-lib';
import { DynamicsCrmSettings } from 'app/model/dataflow/dataset-settings/dynamics-crm-settings';
import { DataFlowSource } from 'app/model/dataflow/dataflow-source';
import { DataFlowSink } from 'app/model/dataflow/dataflow-sink';

@DataFlowDSLAdapterRegistry.adapter({
    model: Metamodel.modelFor(DynamicsCrmSettings)
})
export class DynamicsCrmAdapter extends DynamicsAdapter {
    protected _generateSetting(owner: DataFlowSource | DataFlowSink): DynamicsCrmSettings {
        const setting = Owned.create<DynamicsCrmSettings>(DynamicsCrmSettings.MODEL, owner);
        setting.initialize(undefined);
        return setting;
    }
}
